module.exports = __webpack_public_path__ + "static/media/usersSample.d6a034d9.xlsx";